import React from 'react';

import { useStreamTimeOffset } from '@vlabs/monokit/entities/streams';
import InfoRow from '@vlabs/shared/components/info-row/InfoRow';
import { useImage, usePeopleCountThresholdInfo } from '@vlabs/shared/hooks';
import { CopyButton, Panel } from '@vlabs/uikit';
import { CircleBar } from '@vlabs/uikit/components/circle-bar/CircleBar';
import { useTranslation } from 'react-i18next';

import st from './CrowdDetails.module.sass';
import { ImageBlock } from './ImageBlock';
import { InfoBlock } from './InfoBlock';

export const CrowdDetails = ({ event }) => {
  const { t } = useTranslation();
  const { label } = usePeopleCountThresholdInfo(event);

  const createTime = event?.create_time;
  const peopleCoordinates = event?.event?.overview?.people_coordinates ?? [];
  const streamId = event?.event?.stream_id;
  const fullFrame = useImage(event?.event?.overview?.image);
  const { timeInterval } = useStreamTimeOffset(event?.event?.stream_id, event?.event?.overview?.time_offset);

  return (
    <div className={st.Root}>
      {/* FIXME передаелть InfoBlock, скорее всего оттуда вынесется только локация, остальное будет в каждой ВА прописываться */}
      <InfoBlock event={event} />

      <div className={st.FrameScoreWrapper}>
        <ImageBlock
          createTime={createTime}
          detections={peopleCoordinates}
          detectionType="point"
          eventType={event?.event_type}
          fullFrame={fullFrame}
          streamId={streamId}
        />

        {/* FIXME передаелть ScoreBlock и оставить там только сам CircleBar когда будет рефакторинг остальных деталей ВА */}
        <Panel className={st.Panel}>
          {event?.event?.people_count && (
            <div className={st.CircleBarWrapper}>
              <div className={st.CircleBarTitle}>
                {t('videoAnalytics:details.crowd.circle bar.label')}
              </div>
              <div className={st.CircleBar}>
                <CircleBar value={event?.event?.people_count} />
              </div>
              <span className={st.CrowdThreshold}>{`${t('threshold')}: ${label || t('absent')}`}</span>
            </div>
          )}

          {!event?.event?.people_count && (
            <div className={st.CircleBarWrapper}>
              <div className={st.CircleBarTitle}>
                {t('videoAnalytics:details.crowd.circle bar.label')}
              </div>
              <span className={st.CircleBarSubtitle}>{t('videoAnalytics:details.not computable')}</span>
            </div>
          )}

          <div className={st.Divider} />
          <InfoRow
            className={st.VideoAnalyticDetails__InfoRow}
            title={t('videoAnalytics:frame time')}
            value={timeInterval}
          />

          <InfoRow
            className={st.VideoAnalyticDetails__InfoRow}
            title={t('videoAnalytics:crowdAnalyticDetails.details.people coordinates')}
            value={<CopyButton value={event?.event?.overview?.people_coordinates} />}
          />
        </Panel>
      </div>

    </div>
  );
};
